<template>
 <Head>
    <title>Admin Dashboard | {{$page.props.appName}}</title>
    <meta name="description" :content="'Admin Dashboard ' + $page.props.appName">
  </Head>
  <div class="w-full flex p-3 xl:flex-row lg:flex-row md:flex-col sm:flex-col flex-col items-center justify-center">
    <Link
      href="/admin/staff"
      class="
        xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold
      "
    >
      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>

        <p>Staff</p>
      </div>
    </Link>

    <Link
      href="/admin/announcements"
      class="
       xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold
      "
    >
      <div class="flex items-center flex-col">
        <svg
          class="h-24 w-24"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          ></path>
        </svg>

        <p>Announcements</p>
      </div>
    </Link>

    <Link
      href="/admin/reports"
      class="
        xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold
      "
    >
      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>

        <p>Reports</p>
      </div>
    </Link>
  </div>

  <div class="w-full flex p-3 xl:flex-row lg:flex-row md:flex-col sm:flex-col flex-col items-center justify-center">
    <Link
      href="/admin/department"
      class="
       xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold
      "
    >
      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
            clip-rule="evenodd"
          />
          <path
            d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"
          />
        </svg>

        <p>Departments</p>
      </div>
    </Link>

    <Link
      href="/admin/site"
      class="
        xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold
      "
    >
      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <p>Sites</p>
      </div>
    </Link>

    <Link
      href="/admin/skill"
      class="
        xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold
      "
    >
      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>

        <p>Skills</p>
      </div>
    </Link>

    <Link
      href="/admin/skillgroup"
      class="xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold

      "
    >
      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>

        <p>Skill Groups</p>
      </div>
    </Link>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link,Head },
};
</script>